const namespaced = true

const state = {
  itemType: 'room',
}

const getters = {
}

const actions = {
  setItemType({ commit }, itemType) {
    commit('setItemType', itemType)
  },
}

const mutations = {
  setItemType(state, itemType) {
    state.itemType = itemType
  },
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/palette.js